export default __webpack_public_path__ + "static/investment-image-3-9850724d6f0bb957ed5af975485e1516.jpg";